import { ValidationStatus } from 'types/shared'

export const VALIDATION_STATUSES = {
  VALID: 'valid',
  INVALID: 'invalid',
  PENDING: 'pending'
} satisfies Record<string, ValidationStatus>

export const MULTISELECTION_SEPARATOR = ', '
